import { Action } from '@ngrx/store';
import { OrderActions } from '../order-actions.enum';
import { PersistedOrder } from '../persisted-order';

export class UpdateOrderProgressSuccessAction implements Action {
  readonly type: typeof OrderActions.UPDATE_ORDER_PROGRESS_SUCCESS =
  OrderActions.UPDATE_ORDER_PROGRESS_SUCCESS;

  constructor(public order: PersistedOrder) {}
}
